import { ArrowLeftOutlined } from '@ant-design/icons';
import { Heading } from '@mm/components';
import { useResolutionInfo } from '@mm/hooks';
import { useViewActions } from '@mm/state/actions/viewActions';
import { StoreState } from '@mm/state/store-interfaces';
import React from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { useSelector } from 'react-redux';
import CollapsibleContentContainer from '../../../../../common/components/CollapsibleContentContainer/CollapsibleContentContainer';
import {
  getMMdndEvents,
  MMdndContext,
} from '../../../../../common/helpers/MMdndContext';
import { DialoguePreview } from '../../../../../modules/DailoguePreview/DialoguePreview';
import { MOBILE_THRESHOLD } from '../../../../constants/screenSize';
import { AwaySetings } from '../../../../features/beta/modules/AutomationRules/BusinessHours/AwaySettings/AwaySettings';
import { TimezoneAndWeekDayPicker } from '../../../../features/beta/modules/AutomationRules/BusinessHours/TimezoneAndWeekDayPicker/TimezoneAndWeekDayPicker';
import { SlideoutMenu } from '../../components/SlideoutMenu';
import { useSlideoutOnClose } from '../SlideoutEmail/SlideoutEmail';

import styles from './BusinessHoursSlideoutEditor.module.css';

export const BusinessHoursSlideoutEditor = () => {
  const viewActions = useViewActions();
  const dndEvents = getMMdndEvents();
  const { screenWidth } = useResolutionInfo();
  const isMobile = screenWidth <= MOBILE_THRESHOLD;
  const awayResponderPage = useSelector((state: StoreState) =>
    state.page.entities.find(p => p.kind === 'away_responder'),
  );
  const { setRef } = useSlideoutOnClose();

  return (
    <SlideoutMenu className={styles.menu} setRef={setRef}>
      <SlideoutMenu.Header className={styles.header} closeIcon="close">
        <Heading size={3} className={styles.heading}>
          <ArrowLeftOutlined
            onClick={() => viewActions.hideSlideoutMenu()}
            className={styles.headerBackButton}
          />
          Business Hours Settings
        </Heading>
      </SlideoutMenu.Header>
      <SlideoutMenu.Content className={styles.content}>
        <MMdndContext.Provider value={dndEvents}>
          <div className={styles.container}>
            <div className={styles.configArea}>
              <CollapsibleContentContainer
                orderNumber="1"
                containerName="Set hours of operations for your business"
                className={styles.collapsibleContainer}
                useCircleNumberStyle
              >
                <TimezoneAndWeekDayPicker
                  className={styles.timezonePicker}
                  useCheckboxStyle
                />
              </CollapsibleContentContainer>
              <DragDropContext
                onDragStart={dndEvents.onDragStart}
                onDragUpdate={dndEvents.onDragUpdate}
                onDragEnd={dndEvents.onDragEnd}
              >
                <CollapsibleContentContainer
                  orderNumber="2"
                  containerName="Away Settings"
                  className={styles.collapsibleContainer}
                  useCircleNumberStyle
                >
                  <AwaySetings className={styles.awaySettings} />
                </CollapsibleContentContainer>
              </DragDropContext>
            </div>
            {!isMobile && awayResponderPage && (
              <DialoguePreview
                dialogueId={awayResponderPage.id}
                className={styles.dialoguePreview}
                sticky
              />
            )}
          </div>
        </MMdndContext.Provider>
      </SlideoutMenu.Content>
    </SlideoutMenu>
  );
};
